export { CapturePreview as default } from './CapturePreview';
